import script from "./ScoreDistribution.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreDistribution.vue?vue&type=script&setup=true&lang=js"

import "./ScoreDistribution.vue?vue&type=style&index=0&id=a79410e2&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/AIDean/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a79410e2"]])

export default __exports__